<template>
  <div class="wrapper" id="mapDiv" style="height: 100%; width: 100%">
    <GmapMap
      ref="mapRef"
      :center="center"
      :zoom="11.5"
      class="mapCircle"
      style="height: 100%; width: 100%"
      :options="{
        zoomControl: false,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: true,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      }"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in mapMarkers"
        :position="m.position"
        :clickable="true"
        @click="goToCenter(m.position)"
        :draggable="enableDragToUpdate"
        :icon="m.icon"
        :zIndex="12"
        @dragend="markerMoved(m, $event.latLng)"
      />
    </GmapMap>
    <i class="top"></i>
    <i class="right"></i>
    <i class="bottom"></i>
    <i class="left"></i>
    <i class="top left"></i>
    <i class="top right"></i>
    <i class="bottom left"></i>
    <i class="bottom right"></i>
    <div
      v-if="showStateSummary == true"
      class="state-summary"
      style="margin-top: 60px"
    >
      <TaxiMapStateSummary
        :taxis="taxis"
        :bookings="bookings"
        :customersInApp="customersForMap.length"
        :showCustomersInApp="showCustomersInApp"
      ></TaxiMapStateSummary>
    </div>
  </div>
</template>

<script>
import TaxiMapStateSummary from "@/components/overwatch/TaxiMapStateSummary.vue";
import { gmapApi } from "vue2-google-maps";

import { Overwatch } from "@/components/util/Overwatch.js";

import createCustomerMapMarker from "@/components/util/CustomerMapMarker.js";
import createHTMLMapMarker from "@/components/util/HTMLMarker.js";
import { setTimeout } from "timers";

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "OverwatchMap",
  components: {
    TaxiMapStateSummary,
  },
  props: {
    height: {
      type: Number,
      default: 500,
    },
    taxis: Array,
    bookings: Array,
    setSelectedTaxi: Function,
    showStateSummary: {
      type: Boolean,
      default: true,
    },
    enableDragToUpdate: {
      type: Boolean,
      default: false,
    },
    customersForMap: {
      type: Array,
      default: () => [],
    },
    showCustomersInApp: {
      type: Boolean,
      default: false,
    },
    navigateToTaxiId: {
      type: Number,
      default: null,
    },
    zone: Object
  },
  data: function () {
    return {
      markers: [],
      mapMarkers: [],
      center: this.$store.state.center,
      panned: false,
      token: "",
      map: null,
      polyline: null,
      driverTracePolylines: [],
      geocoder: null,
      zonePolygon: null
    };
  },
  watch:  {
    zone: function() {
      if (this.zone == undefined || this.zone == null) {
        return;
      }
      
      this.showZone(this.zone);
    },
    taxis () {
      this.updateMarkers(null)
    }
  },
  mounted: function () {
    // this.recenter()
    console.log("MAP CENTER " + JSON.stringify(this.center));

    var vm = this;
    this.$refs.mapRef.$mapPromise.then((map) => {
      this.map = map;
      this.recenter()

      var trafficLayer = new google.maps.TrafficLayer();
      trafficLayer.setMap(map);

      this.updateMarkers(-1);

      var geocoder = new google.maps.Geocoder();
      this.geocoder = geocoder;

      console.log(geocoder);
    });
  },
  computed: {
    google: gmapApi,
    availabilityCenter () {
      return this.$store.getters['availabilityRegion/getCenter']
    },
    mapCenter () {
      if (this.availabilityCenter) {
        return {
          lat: this.availabilityCenter.center_location.lat,
          lng: this.availabilityCenter.center_location.lon,
        }
      } else {
        return this.center
      }
    }
  },
  methods: {
    markerMoved: function (marker, location) {
      console.log("MARKER MOVED");

      var vm = this;

      try {
        if (marker.location.custom == true) {
          console.log("CUSTOM LOCATION SO NOT DOING ANYTHING");

          marker.location.latLng.latitude = location.lat();
          marker.location.latLng.longitude = location.lng();

          marker.location.invalid = true;
          marker.location.custom = true;

          vm.$emit("placechanged");
        } else {
          console.log("Reverse Geocoding");

          this.geocoder.geocode({ location: location }, function (
            results,
            status
          ) {
            if (status === "OK") {
              console.log(results);

              let addressComponents = {
                street_number: "short_name",
                route: "long_name",
                locality: "long_name",
                administrative_area_level_1: "short_name",
                country: "long_name",
                postal_code: "short_name",
              };
              let returnData = {};

              var place = results[0];

              if (place.address_components !== undefined) {
                // Get each component of the address from the place details
                for (let i = 0; i < place.address_components.length; i++) {
                  let addressType = place.address_components[i].types[0];
                  if (addressComponents[addressType] != undefined) {
                    let val =
                      place.address_components[i][
                        addressComponents[addressType]
                      ];
                    returnData[addressType] = val;
                  }
                }

                returnData["latitude"] = place.geometry.location.lat();
                returnData["longitude"] = place.geometry.location.lng();
                // return returnData object and PlaceResult object

                var address = place.formatted_address;

                if (
                  place.types.includes("establishment") &&
                  place.name != "undefined" &&
                  place.name != undefined &&
                  place.name != null
                ) {
                  // console.log("PLACE NAME " + place.name);
                  address = place.name + ", " + address;
                }

                marker.location.description = address;

                vm.sendLocationToServer(
                  place.geometry.location.lat(),
                  place.geometry.location.lng(),
                  address,
                  function (loc) {
                    marker.location.id = loc.id;
                    vm.$emit("placechanged");
                  }
                );
              }
            } else {
              window.alert("Geocoder failed due to: " + status);
            }
          });
        }
      } catch (e) {
        print(e);
      }
    },
    sendLocationToServer(latitude, longitude, description, success) {
      axios({
        url: `${this.$store.state.apiUrl}/location/add`,
        method: "POST",
        params: {
          lat: latitude,
          lon: longitude,
          description: description,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(function (res) {
          // console.log(res.data);
          var loc = {
            id: res.data.id,
            description: res.data.description,
            latLng: {
              latitude: res.data.lat,
              longitude: res.data.lon,
            },
          };

          success(loc);
        })
        .catch((err) => console.error(err));
    },
    goToCenter: function (p) {
      this.map.setCenter(p);
      this.map.setZoom(12.5);
    },
    recenter: function () {
      this.map.setCenter(this.mapCenter);
      this.map.setZoom(11.5);
    },
    clear: function () {

      console.log("Clearing Overwatch Map");

      if (this.polyline != null) {
        this.polyline.setMap(null);
      }

      if (this.zonePolygon != null) {
        this.zonePolygon.setMap(null);
        console.log("Removed Polygon");
      }

      this.mapMarkers = [];
    },
    zoomToMakingBooking: function (job) {
      console.log("Zoom to making booking");

      if (this.polyline != null) {
        this.polyline.setMap(null);
      }

      var bounds = new google.maps.LatLngBounds();

      this.mapMarkers = [];

      if (job.pickup_location.latLng != null) {
        this.mapMarkers.push({
          location: job.pickup_location,
          position: {
            lat: job.pickup_location.latLng.latitude,
            lng: job.pickup_location.latLng.longitude,
          },
          icon: {
            url: "/img/map/pickup_marker.png",
            anchor: new google.maps.Point(13, 32),
          },
          zIndex: 12,
        });
      }

      bounds.extend({
        lat: job.pickup_location.latLng.latitude,
        lng: job.pickup_location.latLng.longitude,
      });

      if (job.destinations != null && job.destinations.length > 0) {
        if (job.destinations[0].latLng != null) {
          this.mapMarkers.push({
            location: job.destinations[0],
            position: {
              lat: job.destinations[0].latLng.latitude,
              lng: job.destinations[0].latLng.longitude,
            },
            icon: {
              url: "/img/map/destination_marker.png",
              anchor: new google.maps.Point(13, 32),
            },
            zIndex: 12,
          });

          bounds.extend({
            lat: job.destinations[0].latLng.latitude,
            lng: job.destinations[0].latLng.longitude,
          });
        }

        for (var i = 1; i < job.destinations.length; i++) {
          if (job.destinations[i].latLng != null) {
            this.mapMarkers.push({
              location: job.destinations[i],
              position: {
                lat: job.destinations[i].latLng.latitude,
                lng: job.destinations[i].latLng.longitude,
              },
                icon: {
                url: `/img/map/pin_${i}.png`,
                anchor: new google.maps.Point(14, 34),
              },
              zIndex: 12,
            });

            bounds.extend({
              lat: job.destinations[i].latLng.latitude,
              lng: job.destinations[i].latLng.longitude,
            });
          }
        }
      }

      this.showZone();

      this.map.fitBounds(bounds, 70);

      if (this.mapMarkers.length == 1) {
        this.map.setZoom(12.5);
      }
    },
    showZone: function(zone) {

        if (this.zonePolygon != null) {
          this.zonePolygon.setMap(null);
        }

        if (zone == null) {
          return;
        }

        var polygonCoords = [];
        var polygonJSON = this.zone.area;

        for (var i = 0; i < polygonJSON.length; i++) {
          polygonCoords.push({
            lat: polygonJSON[i][0],
            lng: polygonJSON[i][1]
          });
        }

        this.zonePolygon = 
          this.addPolygon(polygonCoords, "#fefefe", this.zone.name)
    },
    zoomToBookingTaxi: function (job, taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      if (job == null) {
        this.map.setCenter({
          lat: taxi.lat,
          lng: taxi.lon,
        });

        this.map.setZoom(14.0);
        console.log("Taxi had no job");
        return;
      }

      var bounds = new google.maps.LatLngBounds();

      this.mapMarkers.push({
        location: job.pickup_location,
        position: {
          lat: job.pickup_location.lat,
          lng: job.pickup_location.lon,
        },
        icon: {
          url: "/img/map/pickup_marker.png",
          anchor: new google.maps.Point(16, 16),
        },
        zIndex: 12,
      });

      bounds.extend({
        lat: job.pickup_location.lat,
        lng: job.pickup_location.lon,
      });

      if (job.destinations != null && job.destinations.length > 0) {
        this.mapMarkers.push({
          location: job.destinations[0],
          position: {
            lat: job.destinations[0].lat,
            lng: job.destinations[0].lon,
          },
          icon: {
            url: "/img/map/destination_marker.png",
            anchor: new google.maps.Point(13, 32),
          },
          zIndex: 12,
        });

        bounds.extend({
          lat: job.destinations[0].lat,
          lng: job.destinations[0].lon,
        });

        for (var i = 1; i < job.destinations.length; i++) {
          this.mapMarkers.push({
            location: job.destinations[i],
            position: {
              lat: job.destinations[i].lat,
              lng: job.destinations[i].lon,
            },
            icon: {
              url: `/img/map/pin_${i}.png`,
              anchor: new google.maps.Point(14, 34),
            },
            zIndex: 12,
          });

          bounds.extend({
            lat: job.destinations[i].lat,
            lng: job.destinations[i].lon,
          });
        }
      }

      if (taxi != null) {
        bounds.extend({
          lat: taxi.lat,
          lng: taxi.lon,
        });
      }

      var route = job.route;

      if (route != null) {
        var decodedPath = this.decodePoly(route.route_geometry);

        for (var i = 0; i < decodedPath.length; i++) {
          bounds.extend(decodedPath[i]);
        }

        this.polyline = new google.maps.Polyline({
          path: decodedPath,
          geodesic: false,
          strokeColor: "#000000",
          strokeOpacity: 1.0,
          strokeWeight: 3,
        });

        this.polyline.setMap(this.map);
      }

      this.map.fitBounds(bounds, 70);

    },
    showDriverTrace: function (driverTrace, booking, recenter, showTaxi) {
      console.log("Showing driver trace");

      var bounds = new google.maps.LatLngBounds();

      var decodedPath = [];

      this.driverTracePolylines = [];

      var onWayToPickupTrace = [];
      var arrivedTrace = [];
      var pobTrace = [];

      for (var i = 0; i < driverTrace.length; i++) {
        decodedPath.push({
          lat: driverTrace[i].lat,
          lng: driverTrace[i].lon,
          time: moment(driverTrace[i].time, "YYYY-MM-DD HH:mm:ss"),
        });
        bounds.extend(decodedPath[i]);

        if (
          booking.pob_time != null &&
          decodedPath[i].time.isAfter(
            moment(booking.pob_time, "DD/MM/YYYY HH:mm:ss")
          )
        ) {
          pobTrace.push(decodedPath[i]);
        } else if (
          booking.arrived_time != null &&
          decodedPath[i].time.isAfter(
            moment(booking.arrived_time, "DD/MM/YYYY HH:mm:ss")
          )
        ) {
          arrivedTrace.push(decodedPath[i]);
        } else {
          onWayToPickupTrace.push(decodedPath[i]);
        }
      }

      if (onWayToPickupTrace.length > 0) {
        var onWayToPickupPolyline = new google.maps.Polyline({
          path: onWayToPickupTrace,
          geodesic: false,
          strokeColor: "#fff96c",
          strokeOpacity: 1.0,
          strokeWeight: 4,
        });

        onWayToPickupPolyline.setMap(this.map);
        this.driverTracePolylines.push(onWayToPickupPolyline);

        console.log("Added on way to pickup trace");
      } else {
        console.log("No on way to pickup trace");
      }

      if (arrivedTrace.length > 0) {
        var arrivedPolyline = new google.maps.Polyline({
          path: arrivedTrace,
          geodesic: false,
          strokeColor: "#e699fd",
          strokeOpacity: 1.0,
          strokeWeight: 4,
        });

        arrivedPolyline.setMap(this.map);
        this.driverTracePolylines.push(arrivedPolyline);

        console.log("Added arrived trace");
      } else {
        console.log("No arrived trace");
      }

      if (pobTrace.length > 0) {
        var pobPolyline = new google.maps.Polyline({
          path: pobTrace,
          geodesic: false,
          strokeColor: "#6cddff",
          strokeOpacity: 1.0,
          strokeWeight: 4,
        });

        pobPolyline.setMap(this.map);
        this.driverTracePolylines.push(pobPolyline);
        
        console.log("Added pob trace");
      } else {
        console.log("No pob trace");
      }

      if (showTaxi) {
        var coords = driverTrace[driverTrace.length - 1];

        console.log({
          position: {
            lat: coords.lat,
            lng: coords.lon,
          },
        });

        this.mapMarkers = this.mapMarkers.filter(function (m) {
          return m.key != "TAXI";
        });

        this.mapMarkers.push({
          key: "TAXI",
          position: {
            lat: coords.lat,
            lng: coords.lon,
          },
          icon: {
            url: "/img/map/taxi_marker.png",
            anchor: new google.maps.Point(13, 32),
          },
          draggable: false,
          zIndex: 12,
        });
        console.log("show taxi");
      }

      // if (recenter) {
        this.map.fitBounds(bounds, 70);
      // }
    },
    hideDriverTrace: function () {
      console.log(this.driverTracePolylines);
      this.driverTracePolylines.forEach(function (p) {
        // console.log(p);
        p.setMap(null);
      });

      this.driverTracePolylines = [];
    },
    showBookingRoute: function (geometry) {
      var bounds = new google.maps.LatLngBounds();

      var decodedPath = this.decodePoly(geometry);

      for (var i = 0; i < decodedPath.length; i++) {
        bounds.extend(decodedPath[i]);
      }


      this.polyline = new google.maps.Polyline({
        path: decodedPath,
        geodesic: false,
        strokeColor: "#0000FF",
        strokeOpacity: 1.0,
        strokeWeight: 2,
      });

      this.polyline.setMap(this.map);
      this.map.fitBounds(bounds, 70);
    },
    hideBookingRouteTrace: function () {
      this.polyline.setMap(null);
    },
    zoomToTaxi: function (selectedTaxi) {
      if (this.polyline != null) {
        this.polyline.setMap(null);
      }

      this.mapMarkers = [];
      this.mapMarkers = this.mapMarkers;

      var taxi = this.taxis.find(function (t) {
        return t.id == selectedTaxi;
      });

      if (taxi == null) {
        this.recenter();

        return;
      }

      var ow = new Overwatch(this.taxis, this.bookings);
      var job = ow.getJobForTaxi(taxi.id);

      this.zoomToBookingTaxi(job, taxi);
    },
    decodePoly: function (encoded) {
      var points = [];
      var index = 0,
        len = encoded.length;
      var lat = 0,
        lng = 0;

      while (index < len) {
        var b,
          shift = 0,
          result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        var dlat = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
        lat += dlat;

        shift = 0;
        result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        lng += (result & 1) !== 0 ? ~(result >> 1) : result >> 1;

        points.push({ lat: lat / 1e5, lng: lng / 1e5 });
      }

      return points;
    },
    getMap: function () {
      var map = this.$refs.mapRef.map;

      return map;
    },
    updateMarkers: function (selectedTaxi) {
      this.markers.map(function (m) {
        m.remove();
      });

      this.markers.length = 0;

      if (this.taxis != null) {
        for (var i = 0; i < this.taxis.length; i++) {
          var taxi = this.taxis[i];

          this.addTaxiMarker(taxi, selectedTaxi);
        }
      }

      if (this.customersForMap != null) {
        for (var i = 0; i < this.customersForMap.length; i++) {
          var customerForMap = this.customersForMap[i];

          this.addCustomerForMapMarker(customerForMap);
        }
      }
    },
    addCustomerForMapMarker: function (customerForMap) {
      var latLng = new google.maps.LatLng(
        customerForMap.latLng.lat,
        customerForMap.latLng.lon
      );

      let marker = createCustomerMapMarker({
        latlng: latLng,
        map: this.map,
        html: `<p></p>`,
        color: customerForMap.booking_made_time == null ? "#77b1ff" : "#00FF00",
      });

      this.markers.push(marker);
    },
    callsignPrefixForDriver(driver) {
      var group = "";

      for (var i = 0; i < this.$store.state.driverGroups.length; i++) {
        if (driver.driver_group_id == this.$store.state.driverGroups[i].id) {
          group = this.$store.state.driverGroups[i].callsignPrefix;
        }
      }

      
      return group;
    },
    addTaxiMarker: function (taxi, selectedTaxi) {
      var latLng = new google.maps.LatLng(taxi.lat, taxi.lon);

      var ow = new Overwatch(this.taxis, this.bookings);

      var setSelectedTaxi = this.setSelectedTaxi;

      let marker = createHTMLMapMarker({
        latlng: latLng,
        map: this.map,
        html: `<p style="text-align: center; font-weight: 600">${this.callsignPrefixForDriver(taxi)}${taxi.driver.callsign}</p>`,
        color: ow.colorForTaxi(taxi),
        click: function () {
          setSelectedTaxi(taxi.id);
        },
        selected: selectedTaxi == taxi.id,
        fade: selectedTaxi != -1,
        zIndex: this.zIndexForTaxi(taxi, ow)
      });

      this.markers.push(marker);
    },
    zIndexForTaxi(taxi, ow) {

      var categoryForTaxi = ow.categoryForTaxi(taxi);

      if (categoryForTaxi == 'available') {
        return 5;
      }

      if (categoryForTaxi == 'running_late') {
        return 4;
      }

      return 3;
    },
    addPolygon: function(coords, color, name) {
      var polygon = new google.maps.Polygon({
        paths: coords,
        editable: false,
        draggable: false,
        strokeColor: color,
        content: name,
        clickable: false
      });

      if (this.infoWindow == null) {
        this.infoWindow = new google.maps.InfoWindow();
      }

      var vm = this;
      var map = this.map;

      var showArrays = function(event) {
        vm.infoWindow.setContent(name);
        vm.infoWindow.setPosition(event.latLng);
        vm.infoWindow.open(map);
      };

      // polygon.addListener("click", showArrays);

      polygon.setMap(map);


      return polygon;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrapper {
  position: relative;
}
.state-summary {
  float: left;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
